import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { TiptapToken } from './tiptap.interface';
import { TiptapService } from './tiptap.service';

const service = new TiptapService();

export interface TiptapState {
   cachedToken: TiptapToken | null;
   tokenExpiration: number | null;
}

const TiptapStore: Module<TiptapState, StoreState> = {
   namespaced: true,
   state: {
      cachedToken: null,
      tokenExpiration: null,
   },
   getters: {
      isTokenValid(state): boolean {
         if (!state.cachedToken || !state.tokenExpiration) return false;
         // Check if token expires within next 60 seconds (add buffer)
         return Date.now() < state.tokenExpiration - 60000;
      },
      token(state): string | null {
         return state.cachedToken?.token || null;
      },
   },
   mutations: {
      SET_TOKEN(state, token: TiptapToken) {
         state.cachedToken = token;
         const expiresDate = new Date(token.expires);
         state.tokenExpiration = expiresDate.getTime();
      },
      CLEAR_TOKEN(state) {
         state.cachedToken = null;
         state.tokenExpiration = null;
      },
   },
   actions: {
      async getToken({ state, commit, getters }) {
         if (getters.isTokenValid) {
            return state.cachedToken;
         }

         const token = await service.getToken();
         commit('SET_TOKEN', token);
         return token;
      },
   },
};

export default TiptapStore;
